import React, { useState, useEffect } from "react";
import moment from "moment";
import CurrencyFormat from "react-currency-format";
import Table from "../../components/Table";
import DeleteConfirmation from "../../components/DeleteConfirmation";
import Toast from "../../components/Toast";
import Modal from "../../components/Modal";
import Button from "../../components/Button";
import FormInput from "../../components/FormInput";
import {
  GET_SUBSCRIPTION_PLAN_URL,
  getData,
  deleteData,
  postData,
  putData,
  ADD_SUBSCRIPTION,
  EDIT_SUBSCRIPTION,
  DELETE_SUBSCRIPTION,
} from "../../utils/api";

const SubscriptionDetails = (props) => {
  const { isCreate, setIsCreate } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [isDeletePopupShown, setIsDeletePopupShown] = useState(false);
  const [isPopupShown, setIsPopupShown] = useState(false);
  const [itemForDelete, setItemForDelete] = useState(null);
  const [params, setParams] = useState({
    limit: 25,
    offset: 0,
    areMoreItemsAvailable: false,
  });
  const [toastParams, setToastParams] = useState({
    message: "",
    type: "",
    id: "",
  });
  const [subscriptionData, setSubscriptionData] = useState({
    planName: "",
    description: "",
    originalPrice: "",
    finalPrice: "",
    noOfLookups: "",
  });
  const [historyItems, setHistoryItems] = useState([]);

  useEffect(() => {
    setIsPopupShown(isCreate);
  }, [isCreate]);

  const resetData = () => {
    setSubscriptionData({
      planName: "",
      description: "",
      originalPrice: "",
      finalPrice: "",
      noOfLookups: "",
    });
  };

  const fetchMore = () => {
    setParams({
      ...params,
      offset: params.offset + params.limit,
    });
  };
  const fetchLess = () => {
    setParams({
      ...params,
      offset: params.offset - params.limit,
    });
  };

  const getSubscriptionHistory = async () => {
    try {
      setIsLoading(true);
      const data = await getData(GET_SUBSCRIPTION_PLAN_URL, {
        count: params.limit,
        offset: params.offset,
      });
      setIsLoading(false);
      setHistoryItems(data.list);
      setParams({
        ...params,
        areMoreItemsAvailable: data.areMoreItemsAvailable,
      });
    } catch (e) {
      console.log("ERROR", e);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getSubscriptionHistory();
  }, [params.offset, params.text, params.limit]);

  const setDelete = (item) => {
    setIsDeletePopupShown(true);
    setItemForDelete(item);
  };

  const setEdit = (item) => {
    setIsCreate(true);
    setSubscriptionData(item);
  };

  const deleteItem = async () => {
    setIsLoading(true);
    try {
      const response = await deleteData(DELETE_SUBSCRIPTION, {
        subscriptionId: itemForDelete.modelId,
      });
      setIsDeletePopupShown(false);
      setIsLoading(false);
      getSubscriptionHistory();
    } catch (e) {
      setToastParams({
        type: "ERROR",
        message: e && e.error ? e.error : e.response.data.error,
        id: new Date().getTime(),
      });
      setIsDeletePopupShown(false);
      setIsLoading(false);
    }
  };

  const postSubscription = async () => {
    try {
      if (
        (subscriptionData.planName || "").length === 0 ||
        (subscriptionData.originalPrice || "").length === 0 ||
        (subscriptionData.finalPrice || "").length === 0 ||
        (subscriptionData.noOfLookups || "").length === 0
      ) {
        setToastParams({
          type: "ERROR",
          message: "Fill All Details",
          id: new Date().getTime(),
        });
        return;
      }
      let data;
      if (subscriptionData?.modelId) {
        data = await putData(EDIT_SUBSCRIPTION, {
          planName: subscriptionData.planName,
          description: subscriptionData.description,
          originalPrice: subscriptionData.originalPrice,
          finalPrice: subscriptionData.finalPrice,
          noOfLookups: subscriptionData.noOfLookups,
          modelId: subscriptionData.modelId,
        });
      } else {
        data = await postData(ADD_SUBSCRIPTION, { ...subscriptionData });
      }

      resetData();
      setIsLoading(false);
      setIsCreate(false);
      setToastParams({
        type: "SUCCESS",
        message:
          data &&
          data.response &&
          data.response.data &&
          data.response.data.message
            ? data.response.data.message
            : "Subscription Successfully!",
        id: new Date().getTime(),
      });
      getSubscriptionHistory();
    } catch (e) {
      console.log("ERROR", e);
      setToastParams({
        type: "ERROR",
        message:
          e && e.response && e.response.data && e.response.data.error
            ? e.response.data.error
            : "Enter Valid Input",
        id: new Date().getTime(),
      });
    }
  };

  return (
    <>
      <Table
        customClassName="pr-16"
        scrollTable={true}
        columns={[
          "Plan Name",
          "Desc",
          "Lookup Count",
          "Original Price",
          "Final Price",
          "Created",
        ]}
        items={(historyItems || []).map((histroy) => {
          const createdDate = moment(histroy.created).format(
            "MM/DD/YYYY hh:mm A"
          );
          return {
            ...histroy,
            created: `${createdDate}`,
            oPrice: (
              <CurrencyFormat
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
                value={histroy.originalPrice}
              />
            ),
            fPrice: (
              <CurrencyFormat
                displayType={"text"}
                thousandSeparator={true}
                prefix={"$"}
                value={histroy.finalPrice}
              />
            ),
          };
        })}
        keys={[
          "planName",
          "description",
          "noOfLookups",
          "oPrice",
          "fPrice",
          "created",
        ]}
        offset={params.offset}
        areMoreItemsAvailable={params.areMoreItemsAvailable}
        fetchMore={fetchMore}
        fetchLess={fetchLess}
        isLoading={isLoading}
        counterDropdown={[25, 50, 100]}
        className="min-wt-1000"
        hideCheckBox={true}
        onCountChange={(value) => {
          setParams({
            ...params,
            limit: value,
          });
        }}
        limit={params.limit}
        actions={["EDIT", "DELETE"]}
        onEdit={setEdit}
        onDelete={setDelete}
      />

      {isPopupShown && (
        <Modal>
          <div className="pt-10 pb-20 pl-10 pr-10 wt-360">
            <div className="flex flex-middle mr-12 pb-20">
              <h1
                className="mr-24 fs-20 c-black"
                style={{ fontWeight: "bold" }}
              >
                {subscriptionData?.modelId ? "Update" : "Add"} Subscription
              </h1>
            </div>

            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110">
                {" "}
                PLAN NAME :<span className="c-red">*</span>
              </div>
              <FormInput
                className={"border-bottom-black flex-1"}
                value={subscriptionData.planName}
                onChange={(e) => {
                  setSubscriptionData({
                    ...subscriptionData,
                    planName: e.target.value,
                  });
                }}
              />
            </div>
            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110"> DESCRIPTION :</div>

              <FormInput
                className={"border-bottom-black flex-1"}
                value={subscriptionData.description}
                onChange={(e) => {
                  setSubscriptionData({
                    ...subscriptionData,
                    description: e.target.value,
                  });
                }}
              />
            </div>

            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110">
                ORIGINAL PRICE :<span className="c-red">*</span>
              </div>

              <FormInput
                type="number"
                className={"border-bottom-black  flex-1"}
                value={subscriptionData.originalPrice}
                onChange={(e) => {
                  setSubscriptionData({
                    ...subscriptionData,
                    originalPrice: e.target.value ? Number(e.target.value) : "",
                  });
                }}
              />
            </div>

            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110">
                FINAL PRICE :<span className="c-red">*</span>
              </div>

              <FormInput
                type="number"
                className={"border-bottom-black  flex-1"}
                value={subscriptionData.finalPrice}
                onChange={(e) => {
                  setSubscriptionData({
                    ...subscriptionData,
                    finalPrice: e.target.value ? Number(e.target.value) : "",
                  });
                }}
              />
            </div>

            <div className="flex flex-middle mb-24 mt-10">
              <div className="c-gray mr-4 wt-110">
                No OF LOOKUP :<span className="c-red">*</span>
              </div>

              <FormInput
                type="number"
                className={"border-bottom-black  flex-1"}
                value={subscriptionData.noOfLookups}
                onChange={(e) => {
                  setSubscriptionData({
                    ...subscriptionData,
                    noOfLookups: e.target.value ? Number(e.target.value) : "",
                  });
                }}
              />
            </div>

            <div className="flex flex-middle flex-right pt-25">
              <Button
                type="modalCancel"
                className="flex flex-middle ht-40 mr-20 btn btn-red"
                onClick={() => {
                  resetData();
                  setIsCreate(false);
                }}
              >
                <span>CANCEL</span>
              </Button>
              <Button
                type="modalSave"
                className="flex  ht-40 flex-middle btn"
                onClick={postSubscription}
              >
                <span>SAVE</span>
              </Button>
            </div>
          </div>
        </Modal>
      )}

      {isDeletePopupShown && (
        <DeleteConfirmation
          type="Subscription"
          name={itemForDelete.planName}
          onClose={setIsDeletePopupShown.bind(null, false)}
          onConfirm={deleteItem}
        />
      )}
      <Toast
        type={toastParams.type}
        message={toastParams.message}
        id={toastParams.id}
      />
    </>
  );
};

export default SubscriptionDetails;
